import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/i18n';
const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="nosotros" className="relative py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-24 overflow-hidden bg-sand w-full" data-id="element-1">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-24 items-center max-w-[1400px] mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:col-span-5 relative z-10" data-id="element-3">
          <p className="uppercase tracking-[0.3em] text-[9px] sm:text-[10px] text-olive font-semibold mb-4 sm:mb-6" data-id="element-4">
            {t('about.tag')}
          </p>
          <h2 className="font-display text-fluid-h2 text-volcanic font-light mb-8 sm:mb-10" data-id="element-5">
            {t('about.title1')} <br data-id="element-6" />
            <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-7">
              {t('about.title2')}
            </span>{' '}
            <br data-id="element-8" />
            {t('about.title3')}
          </h2>
          <div className="space-y-5 sm:space-y-6 text-[14px] sm:text-[15px] leading-relaxed text-volcanic/80 max-w-lg font-light" data-id="element-9">
            <p data-id="element-10">{t('about.desc')}</p>
            <div className="w-12 h-[1px] bg-terracotta my-6 sm:my-8" data-id="element-11" />
            <p className="font-display italic text-xl sm:text-2xl lg:text-3xl text-volcanic leading-tight" data-id="element-12">
              {t('about.quote')}
            </p>
          </div>
          <button onClick={() => scrollTo('#experiencias')} className="mt-10 sm:mt-12 w-full sm:w-auto bg-terracotta text-ivory px-8 sm:px-10 py-4 rounded-md uppercase tracking-[0.2em] text-[10px] sm:text-[11px] hover:bg-terracottaDark transition-colors duration-300" data-id="element-13">
            {t('about.btn')}
          </button>
        </motion.div>

        <div className="lg:col-span-7 relative h-auto lg:h-[800px] flex flex-col lg:block gap-6 mt-8 lg:mt-0" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 60
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative lg:absolute lg:left-0 lg:top-0 w-full lg:w-[65%] h-[300px] sm:h-[500px] lg:h-[85%] overflow-hidden rounded-sm" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/oXtSJ6grVhbDqxbkmSwTQd/ChatGPT_Image_May_27,_2026_at_09_23_19_PM.png" alt="Fundadora de Yes Picnic Tenerife con plantas al atardecer" loading="lazy" className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-[2s] ease-out" data-id="element-16" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 80
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.4,
          delay: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative lg:absolute lg:right-0 lg:bottom-0 w-full lg:w-[50%] h-[250px] sm:h-[400px] lg:h-[65%] overflow-hidden rounded-sm border-0 lg:border-8 border-sand shadow-sm lg:-mt-0 -mt-16 ml-auto max-w-[80%] lg:max-w-full z-10" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/wXobmXZUutGPLWpLxVRgEV/ChatGPT_Image_May_27,_2026_at_04_58_10_PM.png" alt="Yoga al atardecer frente al mar en Tenerife" loading="lazy" className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-[2s] ease-out" data-id="element-18" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.6
        }} className="absolute top-4 right-4 lg:top-12 lg:right-12 bg-ivory/95 backdrop-blur-sm px-6 sm:px-8 py-4 sm:py-6 rounded-sm shadow-sm border border-beige z-20" data-id="element-19">
            <p className="font-script text-terracotta text-2xl sm:text-3xl mb-1" data-id="element-20">
              {t('about.from')}
            </p>
            <p className="text-[8px] sm:text-[10px] tracking-[0.3em] uppercase text-volcanic/60 text-center font-medium" data-id="element-21">
              {t('about.withLove')}
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}